type SitemapLink = {
    id: string
    translations: {
        language: string
        title: string
        addition?: string
        url: string
    }[]
}

export type Sitemap = {
    id: string
    translations: {
        language: string
        title: string
    }[]
    links: SitemapLink[]
}

export const sitemapMenu: Sitemap[][] = [
    [
        {
            id: "immunsystem",
            translations: [
                {
                    language: "de",
                    title: "Immunsystem",
                },
                {
                    language: "en",
                    title: "Immune System",
                },
            ],
            links: [
                {
                    id: "immunsystem-in-der-schwangerschaft",
                    translations: [
                        {
                            language: "de",
                            title: "Immunsystem in der Schwangerschaft",
                            url: "https://life.lavita.com/de/artikel/immunsystem-in-der-schwangerschaft",
                        },
                        {
                            language: "en",
                            title: "Immune system during pregnancy",
                            url: "https://life.lavita.com/en/articles/immune-system-pregnancy",
                        },
                    ],
                },
                {
                    id: "immunsystem-stärken-bei-kindern",
                    translations: [
                        {
                            language: "de",
                            title: "Immunsystem stärken bei Kindern",
                            url: "https://life.lavita.com/de/artikel/immunsystem-staerken-kinder",
                        },
                        {
                            language: "en",
                            title: "Strengthening the immune system in children",
                            url: "https://life.lavita.com/en/articles/strengthening-immune-system-children",
                        },
                    ],
                },
                {
                    id: "nahrungsergaenzungsmittel-fuer-das-immunsystem",
                    translations: [
                        {
                            language: "de",
                            title: "Nahrungsergänzungsmittel für das Immunsystem",
                            url: "https://www.lavita.com/de-de/nahrungsergaenzung-immunsystem",
                        },
                        {
                            language: "en",
                            title: "Supplements for the immune system",
                            url: "https://www.lavita.com/immune-system-supplements",
                        },
                    ],
                },
                {
                    id: "vitamine-fuer-das-immunsystem",
                    translations: [
                        {
                            language: "de",
                            title: "Vitamine für das Immunsystem",
                            url: "https://life.lavita.com/de/artikel/vitamine-fuer-immunsystem",
                        },
                        {
                            language: "en",
                            title: "Vitamins for the immune system",
                            url: "https://life.lavita.com/en/articles/vitamins-for-immune-system",
                        },
                    ],
                },
                {
                    id: "wie-staerke-ich-mein-immunsystem",
                    translations: [
                        {
                            language: "de",
                            title: "Wie stärke ich mein Immunsystem?",
                            url: "https://life.lavita.com/de/artikel/immunsystem-staerken",
                        },
                        {
                            language: "en",
                            title: "How to strengthen your immune system",
                            url: "https://life.lavita.com/en/articles/strengthen-immune-system",
                        },
                    ],
                },
            ],
        },
        {
            id: "muedigkeit",
            translations: [
                {
                    language: "de",
                    title: "Müdigkeit",
                },
                {
                    language: "en",
                    title: "Tiredness",
                },
            ],
            links: [
                {
                    id: "muedigkeit-in-der-schwangerschaft",
                    translations: [
                        {
                            language: "de",
                            title: "Müdigkeit in der Schwangerschaft",
                            url: "https://life.lavita.com/de/artikel/muedigkeit-schwangerschaft",
                        },
                        {
                            language: "en",
                            title: "Fatigue during pregnancy",
                            url: "https://life.lavita.com/en/articles/fatigue-pregnancy",
                        },
                    ],
                },
                {
                    id: "test-warum-bin-ich-so-muede",
                    translations: [
                        {
                            language: "de",
                            title: "Test: Warum bin ich so müde?",
                            url: "https://life.lavita.com/de/artikel/warum-bin-ich-so-muede-test",
                        },
                        {
                            language: "en",
                            title: "Test: Why am I so tired?",
                            url: "https://life.lavita.com/en/articles/why-am-i-so-tired-test",
                        },
                    ],
                },
                {
                    id: "vitamine-gegen-muedigkeit",
                    translations: [
                        {
                            language: "de",
                            title: "Vitamine gegen Müdigkeit",
                            url: "https://life.lavita.com/de/artikel/vitamine-gegen-muedigkeit",
                        },
                        {
                            language: "en",
                            title: "Vitamins for fatigue",
                            url: "https://life.lavita.com/en/articles/vitamins-for-fatigue",
                        },
                    ],
                },
                {
                    id: "was-hilft-gegen-muedigkeit",
                    translations: [
                        {
                            language: "de",
                            title: "Was hilft gegen Müdigkeit?",
                            url: "https://life.lavita.com/de/artikel/was-tun-gegen-muedigkeit",
                        },
                        {
                            language: "en",
                            title: "How to combat tiredness",
                            url: "https://life.lavita.com/en/articles/how-to-combat-fatigue",
                        },
                    ],
                },
            ],
        },
        {
            id: "schwangerschaft",
            translations: [
                {
                    language: "de",
                    title: "Schwangerschaft",
                },
                {
                    language: "en",
                    title: "Pregnancy",
                },
            ],
            links: [
                {
                    id: "ernaehrung-in-der-schwangerschaft",
                    translations: [
                        {
                            language: "de",
                            title: "Ernährung in der Schwangerschaft",
                            url: "https://life.lavita.com/de/artikel/ernaehrung-schwangerschaft",
                        },
                        {
                            language: "en",
                            title: "Nutrition during pregnancy",
                            url: "https://life.lavita.com/en/articles/pregnancy-nutrition",
                        },
                    ],
                },
                {
                    id: "mikronaehrstoffe-in-der-schwangerschaft",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffe in der Schwangerschaft",
                            url: "https://life.lavita.com/de/artikel/schwangerschaft",
                        },
                        {
                            language: "en",
                            title: "Micronutrients during pregnancy",
                            url: "https://life.lavita.com/en/articles/pregnancy",
                        },
                    ],
                },
                {
                    id: "vitamine-in-der-schwangerschaft",
                    translations: [
                        {
                            language: "de",
                            title: "Vitamine in der Schwangerschaft",
                            url: "https://life.lavita.com/de/artikel/schwangerschaft-vitamine",
                        },
                        {
                            language: "en",
                            title: "Vitamins during pregnancy",
                            url: "https://life.lavita.com/en/articles/vitamins-pregnancy",
                        },
                    ],
                },
            ],
        },
        {
            id: "mikronaehrstoffe-vitamine-spurenelemente",
            translations: [
                {
                    language: "de",
                    title: "Mikronährstoffe (Vitamine & Spurenelemente)",
                },
                {
                    language: "en",
                    title: "Micronutrients (Vitamins & Minerals)",
                },
            ],
            links: [
                {
                    id: "a-z-vitamine",
                    translations: [
                        {
                            language: "de",
                            title: "A-Z Vitamine",
                            url: "https://shop.lavita.com/de",
                        },
                        {
                            language: "en",
                            title: "Liquid vitamins",
                            url: "https://shop.lavita.com",
                        },
                    ],
                },
                {
                    id: "mikronaehrstoffe",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffe",
                            url: "https://life.lavita.com/de/artikel/mikronaehrstoffe",
                        },
                        {
                            language: "en",
                            title: "Micronutrients",
                            url: "https://life.lavita.com/en/articles/micronutrients",
                        },
                    ],
                },
                {
                    id: "mikronaehrstoffkonzentrat",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffkonzentrat",
                            url: "https://www.lavita.com/de-de/produkt/mikronaehrstoffkonzentrat",
                        },
                        {
                            language: "en",
                            title: "Micronutrient concentrate",
                            url: "https://shop.lavita.com",
                        },
                    ],
                },
                {
                    id: "multivitamin",
                    translations: [
                        {
                            language: "de",
                            title: "Multivitamin",
                            url: "https://shop.lavita.com/de",
                        },
                        {
                            language: "en",
                            title: "Liquid multivitamin",
                            url: "https://shop.lavita.com",
                        },
                    ],
                },
                {
                    id: "nahrungsergaenzungsmittel",
                    translations: [
                        {
                            language: "de",
                            title: "Nahrungsergänzungsmittel",
                            url: "https://life.lavita.com/de/artikel/nahrungsergaenzungsmittel",
                        },
                        {
                            language: "en",
                            title: "Dietary supplements",
                            url: "https://life.lavita.com/en/articles/supplements",
                        },
                    ],
                },
                {
                    id: "nahrungsergaenzungsmittel-mikronaehrstoffe",
                    translations: [
                        {
                            language: "de",
                            title: "Nahrungsergänzungsmittel Mikronährstoffe",
                            url: "https://www.lavita.com/de-de/nahrungsergaenzung-mikronaehrstoffe",
                        },
                        {
                            language: "en",
                            title: "Micronutrient supplements",
                            url: "https://www.lavita.com/micronutrient-supplements",
                        },
                    ],
                },
                {
                    id: "vitamine-fuer-kinder",
                    translations: [
                        {
                            language: "de",
                            title: "Vitamine für Kinder",
                            url: "https://life.lavita.com/de/artikel/nahrungsergaenzung-kinder",
                        },
                        {
                            language: "en",
                            title: "Vitamins for kids",
                            url: "https://life.lavita.com/en/articles/supplements-kids",
                        },
                    ],
                },
                {
                    id: "vitaminkomplex",
                    translations: [
                        {
                            language: "de",
                            title: "Vitaminkomplex",
                            url: "https://shop.lavita.com/de",
                        },
                        {
                            language: "en",
                            title: "Liquid micronutrient supplement",
                            url: "https://shop.lavita.com",
                        },
                    ],
                },
            ],
        },
    ],
    [
        {
            id: "social-media",
            translations: [
                {
                    language: "de",
                    title: "LaVita auf Social Media, Bewertungsportalen & App Stores",
                },
            ],
            links: [
                {
                    id: "app-store",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " im App Store",
                            url: "https://apps.apple.com/de/app/lavita/id1484793998",
                        },
                    ],
                },
                {
                    id: "instagram",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Instagram",
                            url: "https://www.instagram.com/lavita/",
                        },
                    ],
                },
                {
                    id: "facebook",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Facebook",
                            url: "https://www.facebook.com/lavita/",
                        },
                    ],
                },
                {
                    id: "google-play",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Google Play",
                            url: "https://play.google.com/store/apps/details?id=de.lavita.lavitaapp",
                        },
                    ],
                },
                {
                    id: "kununu",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Kununu",
                            url: "https://www.kununu.com/de/lavita",
                        },
                    ],
                },
                {
                    id: "lifepr",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf lifePR",
                            url: "https://www.lifepr.de/newsroom/lavita-gmbh",
                        },
                    ],
                },
                {
                    id: "linkedin",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf LinkedIn",
                            url: "https://www.linkedin.com/company/lavita-gmbh/",
                        },
                    ],
                },
                {
                    id: "pinterest",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Pinterest",
                            url: "https://www.pinterest.de/lavita/",
                        },
                    ],
                },
                {
                    id: "trusted-shops",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Trusted Shops",
                            url: "https://www.trustedshops.de/bewertung/info_X49E710FC236D0FD6604F8259314C8A7F.html",
                        },
                    ],
                },
                {
                    id: "trustpilot",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Trustpilot",
                            url: "https://de.trustpilot.com/review/lavita.de",
                        },
                    ],
                },
                {
                    id: "xing",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf Xing",
                            url: "https://www.xing.com/pages/lavitagmbh",
                        },
                    ],
                },
                {
                    id: "youtube",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita",
                            addition: " auf YouTube",
                            url: "https://www.youtube.com/@LaVita1999/",
                        },
                    ],
                },
            ],
        },
        {
            id: "informationen",
            translations: [
                {
                    language: "de",
                    title: "Informationen zu LaVita",
                },
                {
                    language: "en",
                    title: "Information for LaVita",
                },
            ],
            links: [
                {
                    id: "beste-online-shops-nahrungsergaenzungsmittel",
                    translations: [
                        {
                            language: "de",
                            title: "Beste Online-Shops Nahrungsergänzungsmittel",
                            url: "https://www.lavita.com/de-de/beste-online-shops-nahrungsergaenzungsmittel-2026",
                        },
                    ],
                },
                {
                    id: "erfahrungen-mit-lavita",
                    translations: [
                        {
                            language: "de",
                            title: "Erfahrungen mit LaVita",
                            url: "https://www.lavita-erfahrungen.de/",
                        },
                    ],
                },
                {
                    id: "lavita-alternative",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Alternative",
                            url: "https://www.lavita.com/de-de/alternativen",
                        },
                        {
                            language: "en",
                            title: "LaVita alternatives",
                            url: "https://www.lavita.com/alternatives",
                        },
                    ],
                },
                {
                    id: "lavita-erfahrungen",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Erfahrungen",
                            url: "https://www.lavita.com/de-de/mikronaehrstoffkonzentrat/kundenstimmen",
                        },
                    ],
                },
                {
                    id: "lavita-inhaltsstoffe",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Inhaltsstoffe",
                            url: "https://www.lavita.com/de-de/mikronaehrstoffkonzentrat/naehrwerte",
                        },
                        {
                            language: "en",
                            title: "LaVita ingredients",
                            url: "https://www.lavita.com/micronutrient-concentrate/ingredients",
                        },
                    ],
                },
                {
                    id: "wo-kann-ich-lavita-kaufen",
                    translations: [
                        {
                            language: "de",
                            title: "Wo kann ich LaVita kaufen?",
                            url: "https://www.lavita.com/de-de/wo-kann-ich-lavita-kaufen",
                        },
                        {
                            language: "en",
                            title: "Where can I buy LaVita?",
                            url: "https://www.lavita.com/where-can-i-buy-lavita",
                        },
                    ],
                },
                {
                    id: "lavita-bewertungen",
                    translations: [
                        {
                            language: "en",
                            title: "LaVita reviews",
                            url: "https://uk.trustpilot.com/review/lavita.de",
                        },
                    ],
                },
            ],
        },
    ],
    [
        {
            id: "lavita-in-den-medien",
            translations: [
                {
                    language: "de",
                    title: "LaVita in den Medien",
                },
                {
                    language: "en",
                    title: "LaVita in the Media",
                },
            ],
            links: [
                {
                    id: "zeit-wirklich-so-gut",
                    translations: [
                        {
                            language: "de",
                            title: "Ist LaVita wirklich so gut?",
                            url: "https://cmk.zeit.de/cms/articles/20677/anzeige/unn/ist-lavita-wirklich-so-gut-test-kritik-bewertung",
                        },
                    ],
                },
                {
                    id: "abendblatt-alternative",
                    translations: [
                        {
                            language: "de",
                            title: "Gibt es eine günstige Alternative zu LaVita?",
                            url: "https://www.abendblatt.de/advertorials/gibt-es-alternativen-fuer-lavita.html",
                        },
                    ],
                },
                {
                    id: "sueddeutsche-vergleich",
                    translations: [
                        {
                            language: "de",
                            title: "Immunsystem-Präparate im Vergleich",
                            url: "https://www.sueddeutsche.de/advertorial/wieser/immunsystem-praeparate-vergleich/",
                        },
                    ],
                },
                {
                    id: "morgenpost-alternative",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Alternative",
                            url: "https://www.morgenpost.de/advertorials/lavita-alternative.html",
                        },
                    ],
                },
                {
                    id: "eatsmarter-erfahrungen",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Erfahrungen",
                            url: "https://eatsmarter.de/ernaehrung/gesund-ernaehren/lavita-erfahrungen",
                        },
                    ],
                },
                {
                    id: "rtl-erfahrungen-muedigkeit",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Erfahrungen Müdigkeit",
                            url: "https://unternehmen.rtl.de/lavita-erfahrungen-muedigkeit.html",
                        },
                    ],
                },
                {
                    id: "falstaff-test",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Erfahrungen & Test",
                            url: "https://www.falstaff.com/at/news/lavita-erfahrungen-test",
                        },
                    ],
                },
                {
                    id: "getestet-test",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita im Einzeltest",
                            url: "https://www.getestet.de/lavita-com-im-einzeltest/",
                        },
                    ],
                },
                {
                    id: "spektrum-test",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita im Test",
                            url: "https://cmk.spektrum.de/cms/articles/20679/anzeige/unn/lavita-im-test",
                        },
                    ],
                },
                {
                    id: "ntv-kritik",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Kritik",
                            url: "https://unternehmen.n-tv.de/lavita-mikronaehrstoff-konzentrat.html",
                        },
                    ],
                },
                {
                    id: "webde-kritik-mikronaehrstoffkonzentrat",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Kritik Mikronährstoffkonzentrat",
                            url: "https://web.de/magazine/partner/LaVita/",
                        },
                    ],
                },
                {
                    id: "faz-kritik-alternative",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Kritik & Alternative",
                            url: "https://www.faz.net/kaufkompass/service/moderne-mikronaehrstoffe-lavita-als-alternative/",
                        },
                    ],
                },
                {
                    id: "chip-test",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Test & Erfahrungen",
                            url: "https://www.chip.de/artikel/LaVita-im-Test-Erfahrung_186135501.html",
                        },
                    ],
                },
                {
                    id: "rtl-mikronaehrstoffe",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Mikronährstoffe",
                            url: "https://unternehmen.rtl.de/lavita-mikronaehrstoffe.html",
                        },
                    ],
                },
                {
                    id: "waz-kritik",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Mikronährstoffkonzentrat Kritik",
                            url: "https://waz.de/advertorials/lavita-mikronaehrstoffkonzentrat-kritik.html",
                        },
                    ],
                },
                {
                    id: "forbes-test",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita Mikronährstoffkonzentrat Test",
                            url: "https://www.forbes.at/artikel/was-steckt-hinter-dem-mikronaehrstoffkonzentrat-lavita-ein-test",
                        },
                    ],
                },
                {
                    id: "sueddeutsche-vertrauen",
                    translations: [
                        {
                            language: "de",
                            title: "LaVita: Vertrauen seit fast 30 Jahren",
                            url: "https://www.sueddeutsche.de/advertorial/lavita/vertrauen-seit-fast-30-jahren/",
                        },
                    ],
                },
                {
                    id: "focus-anwendungsbereiche",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffe Anwendungsbereiche",
                            url: "https://www.focus.de/adv/warum-sind-mikronaehrstoffe-wichtig-worauf-es-im-alltag-wirklich-ankommt_7013c0b7-1a3e-4903-b3e1-abcc26fe23f2.html",
                        },
                    ],
                },
                {
                    id: "chip-darreichungsformen",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffe Darreichungsformen",
                            url: "https://www.chip.de/angebote/unternehmen-anzeige/mikronaehrstoffe-erklaert-welche-rolle-die-darreichungsform-im-alltag-spielt_6c85c607-7963-4227-816f-43a048760967.html",
                        },
                    ],
                },
                {
                    id: "abendblatt-lebensphasen",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffe Lebensphasen",
                            url: "https://www.abendblatt.de/advertorials/welche-mikronaehrstoffe-braucht-der-koerper-taeglich.html",
                        },
                    ],
                },
                {
                    id: "handelsblatt-test",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffkonzentrat LaVita im Test",
                            url: "https://www.handelsblatt.com/adv/firmen/lavita-im-test-die-wahrheit-vorteile-und-nachteile.html",
                        },
                    ],
                },
                {
                    id: "gesundheit-test",
                    translations: [
                        {
                            language: "de",
                            title: "Mikronährstoffkonzentrate im Test",
                            url: "https://www.gesundheit.de/ernaehrung/naehrstoffe/mikronaehrstoffkonzentrate-test-id213368/",
                        },
                    ],
                },
                {
                    id: "freundin-tipps",
                    translations: [
                        {
                            language: "de",
                            title: "Tipps für das Immunsystem",
                            url: "https://www.freundin.de/lifestyle/fitness-gesundheit/3-tricks-die-jetzt-immunsystem-staerken",
                        },
                    ],
                },
                {
                    id: "fitforfun",
                    translations: [
                        {
                            language: "de",
                            title: "Welche Form für das Immunsystem?",
                            url: "https://unternehmen.fitforfun.de/immunsystem-kapseln-oder-saft.html",
                        },
                    ],
                },
                {
                    id: "focus-kaufen",
                    translations: [
                        {
                            language: "de",
                            title: "Wo kann ich LaVita kaufen?",
                            url: "https://unternehmen.focus.de/wo-kann-ich-lavita-kaufen.html",
                        },
                    ],
                },
                {
                    id: "faz-kaufen",
                    translations: [
                        {
                            language: "de",
                            title: "Wo kauft man Produkte für das Immunsystem?",
                            url: "https://cmk.faz.net/cms/articles/19944/anzeige/unn/immunsystem-unterstuetzen-drogerie-apotheke-oder-direktvertrieb",
                        },
                    ],
                },
                {
                    id: "thesun-iron-supplements",
                    translations: [
                        {
                            language: "en",
                            title: "Iron supplements test",
                            url: "https://www.thesun.co.uk/health/39866751/budget-capsules-super-drinks-test-iron-supplements/",
                        },
                    ],
                },
                {
                    id: "healthwellbeing",
                    translations: [
                        {
                            language: "en",
                            title: "How to choose the right micronutrient supplement",
                            url: "https://www.healthwellbeing.com/choose-the-right-supplement-lavita-micronutrient-concentrate/",
                        },
                    ],
                },
                {
                    id: "naturalhealthwoman",
                    translations: [
                        {
                            language: "en",
                            title: "Micronutrient supplement for long-term health",
                            url: "https://www.naturalhealthwoman.com/which-supplement-supports-long-term-health-wellbeing-lavita-micronutrient-concentrate/",
                        },
                    ],
                },
                {
                    id: "independent",
                    translations: [
                        {
                            language: "en",
                            title: "Switching to a liquid micronutrient supplement",
                            url: "https://independent.co.uk/life-style/supplements-health-vitamins-liquid-b2918033.html/",
                        },
                    ],
                },
            ],
        },
    ],
]
